<template>
  <div>
    <b-carousel
        :id="carouselId"
        :ref="carouselId"
        style="text-shadow: 0px 0px 2px #000"
        :no-animation="noAnimation"
        :indicators="indicators"
        :controls="controls"
        :fade="fade"
        :img-width="imgWidth"
        :img-height="imgHeight"
        :interval="interval"
    >
      <b-carousel-slide
          id="welcome"
      >
        <template #img>
          <div style="margin-top: 25px">
            <h1>Welcome to Solitude</h1>
            <b-img
                center
                src="https://picsum.photos/125/125/?image=58"
                alt="Solitude Welcome Image"
                style="margin-bottom: 25px;"
            />
            <h3>Your sanctuary for tranquility amid life's demands. </h3>
            <h3>In this sacred space, discover the serenity within. Embrace peace through
              guided moments of reflection and personalized solitude plans.</h3>
              <h3>Let Solitude be your companion on this transformative journey towards inner calmness.
              Begin your path to peace now
            </h3>
            <b-button
                variant="warning"
                block
                @click="handleGoToSlide(true)"
            >
              Begin
            </b-button>
          </div>
        </template>
      </b-carousel-slide>
      <b-carousel-slide id="onboarding">
        <template #img>
          <div style="margin-top: 25px">
            <b-img center src="https://picsum.photos/125/125/?image=58" alt="Center image"></b-img>
            <h3>Unlock a personalized journey to tranquility by answering three key
              questions during onboarding:
              <strong>
                <ol style="margin-top: 10px">
                  <li>When can you get away?</li>
                  <li>Where will you go?</li>
                  <li>What will you do?</li>
                </ol>
              </strong>
               Your responses shape a tailored experience, guiding you towards moments of peace and reflection with Solitude.
            </h3>
            <b-button
                variant="warning"
                block
                @click="handleGoToSlide(true)"
            >
              Ok
            </b-button>
          </div>
        </template>
      </b-carousel-slide>
      <b-carousel-slide id="sound">
        <template #img>
          <div style="margin-top: 25px">
            <b-img v-if="false"
                   center src="https://picsum.photos/125/125/?image=58"
                   alt="Center image"/>
            <h3>Choose the sound that resonates with you</h3>
            <div>
              <b-img
                  v-for="(aSound, s) in playListPubSolitudeJSON.sounds"
                  v-bind="mainProps"
                  rounded
                  @click="handleSoundClick(aSound)"
                  :src="`${playListPubSolitudeJSON.asset_url}/${aSound.imgURL}`"
                  style="margin: 10px"
                  :key="`sound_${s}`"
              />
            </div>
            <b-button
                variant="warning"
                block
                @click="handleGoToSlide(true)"
            >
              Skip
            </b-button>
          </div>
        </template>
      </b-carousel-slide>
      <b-carousel-slide id="start">
        <template #img>
          <div style="margin-top: 25px">
            <h3>Click the button when Ready</h3>
            <b-button
                variant="warning"
                block
                pill
                @click="handleGoToSlide(true)"
            >
              Ready
            </b-button>
          </div>
        </template>
      </b-carousel-slide>
      <b-carousel-slide :id="getAwayTime"
                        style=""
      >
        <template #img>
          <h1>{{ optionsSolitudeQuestionsJSON[getAwayTime].question }}</h1>
          <div class="mt-4">
            <b-card
                v-for="(anOption, i) in optionsSolitudeQuestionsJSON[getAwayTime].options"
                img-src="https://placekitten.com/100/100"
                    img-alt="Card image" img-left class="mb-3"
                    style="cursor: pointer"
                    @click="handleAnswerClick(getAwayTime, anOption.value)"
                :key="`gat-${i}`"
            >
              <b-card-text style="color: black">
                <h4>{{ anOption.text }}</h4>
              </b-card-text>
            </b-card>

          </div>
        </template>
      </b-carousel-slide>
      <b-carousel-slide :id="goWherePlace"
                        style=""
      >
        <template #img>
          <h1>{{ optionsSolitudeQuestionsJSON[goWherePlace].question }}</h1>
          <div class="mt-4">
            <b-card
                v-for="(anOption, i) in optionsSolitudeQuestionsJSON[goWherePlace].options"
                img-src="https://placekitten.com/100/100"
                img-alt="Card image" img-left class="mb-3"
                style="cursor: pointer"
                @click="handleAnswerClick(goWherePlace, anOption.value)"
                :key="`gat-${i}`"
            >
              <b-card-text style="color: black">
                <h4>{{ anOption.text }}</h4>
              </b-card-text>
            </b-card>

          </div>
        </template>
      </b-carousel-slide>
      <b-carousel-slide :id="goDoActivity"
                        style=""
      >
        <template #img>
          <h1>{{ optionsSolitudeQuestionsJSON[goDoActivity].question }}</h1>
          <div class="mt-4">
            <b-card
                v-for="(anOption, i) in optionsSolitudeQuestionsJSON[goDoActivity].options"
                img-src="https://placekitten.com/100/100"
                img-alt="Card image" img-left class="mb-3"
                style="cursor: pointer"
                @click="handleAnswerClick(goDoActivity, anOption.value)"
                :key="`gat-${i}`"
            >
              <b-card-text style="color: black">
                <h4>{{ anOption.text }}</h4>
              </b-card-text>
            </b-card>

          </div>
        </template>
      </b-carousel-slide>
      <b-carousel-slide id="create">
        <template #img>
          <div style="margin-top: 25px">
            <b-img center src="https://picsum.photos/125/125/?image=58" alt="Center image"></b-img>
            <h3>Creating Your Solitude</h3>
            <b-button
                variant="warning"
                block
                pill
                @click="handleGoToSlide(true)"
            >
              Hidden Go
            </b-button>
          </div>
        </template>
      </b-carousel-slide>
      <b-carousel-slide id="plan"
                        style=""
      >
        <template #img>
          <h1>Your Plan</h1>
          <div class="mt-4">
            <b-card img-src="https://placekitten.com/200/200"
                    img-alt="Card image" img-left class="mb-3"
                    style="cursor: pointer"
            >
              {{ form }}
              <b-card-text style="color: black">
                <h4>{{ formSolitude[getAwayTime]}}</h4>
                <h4>{{ formSolitude[goDoActivity]}}</h4>
                <h4>{{ formSolitude[goWherePlace]}} </h4>
                <h4>{{ formSolitude[soundChoice]}}</h4>
                <br />
                <b-icon
                    icon="calendar2-plus-fill"
                    scale="2"
                    variant="warning"
                    style="margin-right: 25px"
                />
                <b-icon
                    icon="share-fill"
                    scale="2"
                    variant="warning"
                />
              </b-card-text>
            </b-card>

            <b-button
                variant="warning"
                block
                pill
                @click="handleGoToSlide(true)"
            >
              Begin First Session
            </b-button>
          </div>
        </template>
      </b-carousel-slide>

      <b-carousel-slide id="plan"
                        style=""
      >
        <template #img>
          <h1>Share What's on Your Mind</h1>
          <div class="mt-4">
            <b-img v-if="true"
                   center
                   src="https://www.thisiscolossal.com/wp-content/uploads/2018/08/Isopoly_05.gif"
                   alt="Center image"
            />

            <b-button
                variant="warning"
                block
                pill
                @click="handleGoToSlide(true)"
            >
              Go
            </b-button>
          </div>
        </template>
      </b-carousel-slide>
      <b-carousel-slide id="plan"
                        style=""
      >
        <template #img>
          <h1>Share What's on Your Mind</h1>
          <div class="mt-4">
            <b-img v-if="true"
                   center
                   src="https://www.thisiscolossal.com/wp-content/uploads/2018/08/Isopoly_05.gif"
                   alt="Center image"
            />

            <b-button
                variant="warning"
                block
                pill
                @click="handleGoToSlide(true)"
            >
              Go
            </b-button>
          </div>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import playListPubSolitudeJSON from "../../../assets/json/playListPubSolitude.json";
import optionsSolitudeQuestionsJSON from "../../../assets/json/optionsSolitudeQuestions.json"
export default {
  name: "Display_Solitude_NavSlideView",
  components: {},
  props: {},
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      profile: "user/profile",
      userData: "user/appsData"
    }),
    /* SETTINGS */
    /* USER DATA */
    userDataBends() {
      return this.userData &&
      this.userData &&
      this.userData[`app_${this.resource.toolId}`] &&
      this.userData[`app_${this.resource.toolId}`].bends
          ? this.userData[`app_${this.resource.toolId}`].bends
          : [];
    },
    formSolitude(){
      return this.form;
    }
  },
  methods: {
    handleGoToSlide(isNext){
      if(isNext) {
        this.$refs[this.carouselId].next()  ;
      }
    },
    handleAnswerClick(key, value){
      this.form[key] = value;
      this.handleGoToSlide(true);
    },
    handleSoundClick(soundOption){
      this.form[this.soundChoice] = soundOption;
      this.handleGoToSlide(true);
    }
  },
  data() {
    return {
      getAwayTime: 'get_away_time',
      goWherePlace: 'go_where_place',
      goDoActivity: 'go_do_activity',
      soundChoice: 'sound_choice',
      playListPubSolitudeJSON,
      optionsSolitudeQuestionsJSON,
      form:{},
      formDefault:{
        _started_at: null,
        "get_away_time" : null,
        "go_where_place" : null,
        "go_do_activity":null
      },
      /* SLIDE INFO*/
      viewHeight: 250,
      carouselId: "solitude-views",
      controls: false,
      noAnimation: true,
      indicators: false,
      fade:false,
      slide: 0,
      sliding: null,
      imgWidth:'1024',
      imgHeight:'100vh',
      interval: 0,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
